<template>
    <div>
        <div v-show="dogs && dogs.length > 0">
            <kgr-dog-table
                v-if="view === 'list'"
                :dogs="dogs"
            />
            <kgr-dog-grid
                v-if="view === 'grid'"
                :dogs="dogs"
            />
            <kgr-loading v-if="loading" />
            <div class="kgr-row kgr-text--centered">
                <button
                    v-if="canLoadMore"
                    v-t="'Weitere Ergebnisse laden'"
                    class="kgr-button kgr-button--danger"
                    @click="$emit('loadMore')"
                ></button>
            </div>
        </div>
    </div>
</template>

<script>
import DogGrid from './DogGrid.vue';
import DogTable from './DogTable.vue';
import Loading from '../common/Loading.vue';

export default {
    components: {
        'kgr-dog-grid': DogGrid,
        'kgr-dog-table': DogTable,
        'kgr-loading': Loading,
    },
    props: {
        dogs: {
            type: Array,
            required: false,
            default: () => {
                return []
            }
        },
        view: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
            default: false
        },
        canLoadMore: {
            type: Boolean,
            required: false,
            default: false
        }
    },
}
</script>
